var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.33,
    style: {
      fill: "#FF4B55"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD250"
    },
    points: "271.226,263.896 256,271.509 256,279.122 263.613,279.122 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3A0"
    },
    d: "M256,298.154c-2.104,0-3.806-1.702-3.806-3.806v-15.226c0-2.104,1.702-3.806,3.806-3.806   s3.806,1.702,3.806,3.806v15.226C259.806,296.451,258.104,298.154,256,298.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3A0"
    },
    d: "M256,282.928c-14.95,0-29.388-5.769-40.655-16.244c-1.539-1.431-1.628-3.84-0.197-5.379   c1.442-1.535,3.847-1.617,5.379-0.197c9.854,9.163,22.452,14.207,35.473,14.207c13.021,0,25.619-5.044,35.473-14.207   c1.535-1.424,3.94-1.346,5.379,0.197c1.431,1.539,1.342,3.948-0.197,5.379C285.388,277.159,270.95,282.928,256,282.928z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AADC"
    },
    d: "M256,298.154c-9.758,0-19.21-2.851-27.336-8.248l4.215-6.341c13.739,9.129,32.503,9.129,46.242,0  l4.215,6.341C275.21,295.303,265.758,298.154,256,298.154z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#732D37"
    },
    points: "249.973,246.768 241.567,259.773 240.14,264.055 262.027,258.98 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAD264"
    },
    d: "M232.705,268.238c-10.062,0-22.139-8.468-25.344-27.336l7.509-1.271  c2.661,15.69,12.315,21.006,18.11,20.991c1.777-0.048,3.632-0.662,3.777-1.918c0.171-1.502,0.212-1.859-3.769-3.204  c-2.163-0.732-4.617-1.561-6.338-3.531c-6.962-7.951,2.464-16.367,6.992-20.411c0.799-0.714,1.13-1.32,1.045-1.55  c-0.249-0.65-1.743-1.636-3.427-1.636c-4.836,0-8.505-2.732-9.572-7.126c-1.108-4.55,0.985-9.345,4.97-11.404l3.494,6.765  c-0.933,0.483-1.305,1.859-1.067,2.84c0.093,0.394,0.32,1.312,2.175,1.312c4.661,0,9.096,2.751,10.538,6.535  c0.617,1.613,1.546,5.806-3.085,9.943c-5,4.464-7.992,7.825-6.334,9.717c0.375,0.427,1.985,0.974,3.048,1.331  c3.427,1.16,9.806,3.316,8.891,11.289c-0.572,5.014-5.048,8.494-11.129,8.657C233.028,268.234,232.864,268.238,232.705,268.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#874150"
    },
    d: "M263.613,225.833c0,0,7.613-15.226-7.613-22.838c0,0,53.289-7.613,45.677,60.902l-0.004-0.003  c-4.996-3.997-12.414-11.301-15.063-17.125l-22.997-13.323V225.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#732D37"
    },
    d: "M256,241.058l38.064,22.838c0,0,0,0-15.225,7.613L256,248.671V241.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#783C46"
    },
    d: "M240.774,218.22L240.774,218.22c4.204,0,7.613,3.408,7.613,7.613l-0.008,0.008  c-4.541,4.541-5.667,11.479-2.795,17.224l1.72,3.441c0.717,1.434,1.661,2.744,2.795,3.878l21.126,21.126v-10.521  c0-13.107-3.052-26.033-8.913-37.756l0,0c-3.869-7.737-11.777-12.625-20.427-12.625h-1.111L240.774,218.22L240.774,218.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD250"
    },
    d: "M240.774,210.607l-7.613,7.613v7.613c0,0,9.056-4.592,12.108-6.054  c2.133-1.022,1.745-3.44,0.521-4.604C244.838,214.269,240.774,210.607,240.774,210.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAD264"
    },
    d: "M256,313.379c-35.681,0-64.708-29.027-64.708-64.708h7.613c0,31.484,25.611,57.096,57.096,57.096  s57.096-25.611,57.096-57.096h7.613C320.708,284.352,291.681,313.379,256,313.379z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 199.31,
    cy: 271.26,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 210.73,
    cy: 289.5,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 229.29,
    cy: 303.3,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 313.23,
    cy: 271.26,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 301.81,
    cy: 289.5,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 283.25,
    cy: 303.3,
    r: 5.167
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB478"
    },
    d: "M259.806,301.96h-7.613c-4.204,0-7.613-3.408-7.613-7.613l0,0c0-4.204,3.408-7.613,7.613-7.613h7.613  c4.204,0,7.613,3.408,7.613,7.613l0,0C267.419,298.552,264.011,301.96,259.806,301.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B4B5A"
    },
    d: "M286.61,246.768c2.538,7.454,7.93,14.274,15.063,17.125l0.004,0.003  C309.289,195.382,256,202.994,256,202.994C294.064,202.994,286.61,246.768,286.61,246.768z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/mx.7cdcfaecc763be4a4705db3774eb2011.svg";
export { ForwardRef as ReactComponent };